var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0.5 3.0026C0.5 1.80599 1.47005 0.835938 2.66667 0.835938H19.3333C20.53 0.835938 21.5 1.80599 21.5 3.0026V9.00261C21.5 10.1992 20.53 11.1693 19.3333 11.1693H2.66667C1.47005 11.1693 0.5 10.1992 0.5 9.0026V3.0026Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23 4.00391V8.00391C23.8047 7.66513 24.328 6.87704 24.328 6.00391C24.328 5.13077 23.8047 4.34268 23 4.00391Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.43594C2 2.82842 2.49249 2.33594 3.1 2.33594H18.9C19.5075 2.33594 20 2.82842 20 3.43594V8.56927C20 9.17678 19.5075 9.66927 18.9 9.66927H3.1C2.49249 9.66927 2 9.17678 2 8.56927V3.43594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.da3a263bf5f4fff2abdad51382f4eded.svg";
export { ForwardRef as ReactComponent };